export const errorMessages = {
    PASSWORD_REQUIRED: "Password is required",
    PASSWORD_LENGTH_ERROR: "Password must be atleast 12 characters long",
    PASSWORD_NUMBER_ERROR: "Password must contain at least one number",
    PASSWORD_LOWER_CASE_ERROR: "Password must contain at least one lowercase letter",
    PASSWORD_UPPER_CASE_ERROR: "Password must contain at least one uppercase letter",
    PASSWORD_SYMBOL_ERROR: "Password must contain at least one symbol",
    SELECT_ANY_ONE_FEATURE: "Please select at least one feature.",
};
export const INVALID_CREDENTIALS_LOGIN_MESSAGE = "Invalid credentials. Please try again.";
export const REPEATED_INVALID_LOGIN_ATTEMPTS_MESSAGE = "Repeated invalid login attempts detected. Please try again in 60 seconds.";
export const INVALID_EMAIL_ADDRESS = "Invalid email format";
export const DISPOSABLE_EMAIL_ADDRESS = "Disposable email address is not allowed";
export const OTP_RESENT = "OTP has been resent successfully.";
export const OTP_LENGTH_ERROR = `OTP should be of 4 digits`;
export const RESET_PASSWORD_SUCCESS_MESSAGE = "Password Changed Successfully!";
export const SET_PASSWORD_SUCCESS_MESSAGE = "Password Set Successfully!";
export const RESET_PASSWORD_NOT_VALID = "You are already logged in. Please logout to reset your password.";
export const PROFILE_UPDATE_SUCCESS_MESSAGE = "Your profile has been updated successfully.";
export const TRY_AGAIN_MESSAGE = "Please try again later.";
export const SETTING_SUB_TEXT = "All information related to your organization's license.";
export const MANAGE_AI_SUB_TEXT = "All information related to your organization's AI configurations.";
export const UPLOAD_IMAGE_REQUIRED = "Please upload logos";
export const PASSWORD_RESET_ERR_MSGS = {
    SAME_AS_PREVIOUS: "The password cannot be the same as the current.",
    BLANK_NEW_PASSWORD: "A new password is required.",
    BLANK_CURRENT_PASSWORD: "A current password is required.",
    INCORRECT_CURRENT_PASSWORD: "Incorrect current password.",
    PASSWORD_REQUIRED: "Password is required.",
    PASSWORD_INCORRECT: "Password is incorrect."
};
export const WELCOME_MESSAGE = "Welcome to Admin Portal.";
export const SOMETHING_WENT_WRONG = "Something went wrong.";
export const ROLE_CREATED_SUCCESSFULLY = "Role created successfully.";
export const GROUP_CREATED_SUCCESSFULLY = "Group created successfully.";
export const USER_CREATED_SUCCESSFULLY = "User created successfully.";
export const USER_UPDATED_SUCCESSFULLY = "User updated successfully.";
export const ROLE_UPDATED_SUCCESSFULLY = "Role updated successfully.";
export const NO_USER_ASSIGNED = "No Users Assigned Yet";
export const NO_GROUP_ASSIGNED = "No Group Assigned Yet";
export const NO_ROLE_ASSIGNED = "No Role Assigned Yet";
export const NO_BRAND_FOUND = "No Brands.";
export const NO_BRAND_MESSAGE = "You currently do not have any brands.";
export const FILE_TYPE_ERROR = "Please select an image file";
export const INVALID_INVITE_EXIST = "Invalid email address or user already invited.";
export const BULK_USER_INVITE_SUCCESS = "Users invited successfully";
export const INVITATION_SENT_SUCCESSFULLY = "Invite has been successfully sent.";
export const INVITATION_RESEND_SUCCESSFULLY = "Invite has been successfully resent.";
export const USER_ALREADY_REGISTERED = "User is already registered.";
export const USER_ALREADY_INVITED = "User is already invited.";
export const FIRST_NAME_REQUIRED = "First name is required.";
export const LAST_NAME_REQUIRED = "Last name is required.";
export const REQUIRED_ALL_FIELDS = "Please fill all the required fields.";
export const BRAND_NAME_REQUIRED = "Brand name is required.";
export const COMPANY_NAME_REQUIRED = "Company name is required.";
export const BRAND_CREATED_SUCCESSFULLY = "Brand created successfully.";
export const UPDATE_SUPER_ADMIN_ERROR_MESSAGE = "You cannot update the super admin status"
export const NO_ORGANIZATION_FOUND = "No organizations found."
export const NO_ACTIVITY_IN_DATE_RANGE = "No activity in the given date range."
export const NO_DOCUMENTS_FOUND = "No Documents Added Yet."
export const NO_RECIPIENT_FOUND = "No Recipients Added Yet."
export const NO_GROUP_YET = "No Groups Added Yet."
export const NO_USER_YET = "No Users Added Yet."
export const NO_ROLE_YET = "No Roles Added Yet."
export const NO_LOGS_FOUND = "No Log Found."
export const CREATE_YOUR_GROUPS = "Create your groups here."
export const CREATE_YOUR_ROLES = "Create your roles here."
export const NO_SHARED_ACCESS_MESSAGE = "You haven't shared your account with anyone yet."
export const NO_SHARED_ACCESS_SUB_MESSAGE = "Click the 'Shared access with other' button to start sharing and collaborating with others."
export const NO_SHARED_ACCESS_GRANTED_MESSAGE = "There are no accounts currently shared with you."
export const NO_SHARED_ACCESS_GRANTED_SUB_MESSAGE = "Shared accounts will appear here once anyone shared access with you."
export const ORG_DOMAIN_RESTRICTED = (domains: string) => `Email domain restricted. Please use an email address that ends with one of the authorized domains: ${domains}.`
export const NO_DOMAIN_SPECIFIED = 'No domains specified.'
export const INVALID_CAPTCHA_TOKEN = 'Verification Failed: Please disable any ad blockers or privacy extensions and refresh the page.'
export const TIMEZONE_UPDATE_SUCCESSFULLY = 'Timezone updated successfully.'
export const LOGOUT_REDIRECT_UPDATE_SUCCESSFULLY = 'Logout redirect updated successfully.'
export const WEBHOOK_UPDATE_SUCCESSFULLY = 'Webhook updated successfully.'
export const NO_TEMPLATE_DATA_HEADING = "All Your Templates in One Place";
export const NO_TEMPLATE_DATA_MESSAGE = "You'll find the created templates here.";
export const NO_FORM_DATA_HEADING = "All Your Forms in One Place";
export const NO_TAG_DATA_HEADING = "All Your Tags in One Place";
export const NO_FORM_DATA_MESSAGE = "You'll find the created forms here.";
export const NO_TAG_DATA_MESSAGE = "You'll find the created tags here.";
export const TAG_TEXT = {
    EDIT_MESSAGE: 'Updating this tag will automatically update it in all associated envelopes.',
    DELETE_CONFIRMATION: (tagName: string) => `Are you sure you want to delete the tag "${tagName}" ?`,
    DELETE_MESSAGE: 'This action will remove the tag from all associated envelopes.',
    VALID_TAG_NAME: 'Please enter a valid tag name.',
    FAILED_ADD_TAG: 'Failed to add tag. Please try again.',
    FAILED_EDIT_TAG: 'Failed to edit tag. Please try again.',
    FAILED_DELETE_TAG: 'Failed to delete tag. Please try again.',
}